import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgVolume = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 22,
	height: 18,
	viewBox: "0 0 22 18",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M5.60282 7.00004L9 4.2205V13.7795L5.60282 11H2V7.00004H5.60282ZM1 13H4.88889L10.1834 17.3318C10.2727 17.4049 10.3846 17.4448 10.5 17.4448C10.7761 17.4448 11 17.221 11 16.9448V1.05513C11 0.939709 10.9601 0.827839 10.887 0.738509C10.7121 0.524789 10.3971 0.493289 10.1834 0.668149L4.88889 5.00001H1C0.44772 5.00001 0 5.44772 0 6.00001V12C0 12.5523 0.44772 13 1 13ZM22 8.99994C22 12.2919 20.5539 15.2462 18.2622 17.2621L16.8445 15.8443C18.7758 14.1936 20 11.7397 20 8.99994C20 6.2601 18.7758 3.80623 16.8445 2.15551L18.2622 0.737729C20.5539 2.75362 22 5.70789 22 8.99994ZM17 8.99994C17 7.08824 16.106 5.38542 14.7133 4.28667L13.2842 5.71578C14.3213 6.43849 15 7.63994 15 8.99994C15 10.3599 14.3213 11.5613 13.2842 12.284L14.7133 13.7131C16.106 12.6144 17 10.9115 17 8.99994Z"
	})
});
export default SvgVolume;
